import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleNotch, faList } from "@fortawesome/free-solid-svg-icons";

export default class SideBar extends React.Component {
  constructor() {
    super();
    this.state = {
      toggle: false,
    };
  }

  render() {
    return (
      <div className="sidebar">
        <div className="sidebar-link">
          <button>
            <FontAwesomeIcon className="font-aw" icon={faList} />
            <label title="posts" onClick={this.toggle.bind(this)}>
              پست
            </label>
          </button>
        </div>

        {this.state.posts ? (
          <div className="sidebar-col">
            <Path title="پست جدید" path="/post-new" />
            <Path title="لیست پست ها" path="/post-table" />
          </div>
        ) : null}
        <div className="sidebar-link">
          <button>
            <FontAwesomeIcon className="font-aw" icon={faList} />
            <label title="opportunity" onClick={this.toggle.bind(this)}>
              موقعیت های شغلی
            </label>
          </button>
        </div>
        {this.state.opportunity ? (
          <div className="sidebar-col">
            <Path title="موقعیت جدید" path="/opportunity-new" />
            <Path title="ساخت موقعیت از طریق فایل" path="/opportunity-new-file" />
            <Path title=" لیست موقعیت ها" path="/opportunity-table" />
          </div>
        ) : null}

        <div className="sidebar-link">
          <button>
            <FontAwesomeIcon className="font-aw" icon={faList} />
            <label title="education" onClick={this.toggle.bind(this)}>
              موقعیت های تحصیلی
            </label>
          </button>
        </div>

        {this.state.education ? (
          <div className="sidebar-col">
            <Path title="موقعیت جدید" path="/study-opportunity-new" />
            <Path title="ساخت موقعیت تحصیلی از طریق فایل" path="/opportunity-edu-new-file" />
            <Path title="لیست موقعیت ها" path="/study-opportunity-table" />
          </div>
        ) : null}

        <div className="sidebar-link">
          <button>
            <FontAwesomeIcon className="font-aw" icon={faList} />
            <label title="consultation" onClick={this.toggle.bind(this)}>
              مشاوره ها
            </label>
          </button>
        </div>
        {this.state.consultation ? (
          <div className="sidebar-col">
            <Path title="تمامی مشاوره ها" path="/consultation-table" />
            <Path title="مشاوره های رایگان" path="/consultation-free" />
            <Path title="مشاوره های پرداختی" path="/consultation-paid" />
            <Path
              title=" مشاوره های تماس گرفته نشده"
              path="/consultation-unseen-table"
            />
          </div>
        ) : null}

        <div className="sidebar-link">
          <button>
            <FontAwesomeIcon className="font-aw" icon={faList} />
            <label title="resume" onClick={this.toggle.bind(this)}>
              رزومه
            </label>
          </button>
        </div>
        {this.state.resume ? (
          <div className="sidebar-col">
            <Path title="لیست رزومه ها" path="/all-resume" />
            <Path title="رزومه های دیده نشده" path="/new-resumes" />
            <Path title="رزومه های تحصیلی" path="/resume-for-edus" />
            <Path title="رزومه های شغلی" path="/resume-for-jobs" />
          </div>
        ) : null}

        <div className="sidebar-link">
          <button>
            <FontAwesomeIcon className="font-aw" icon={faList} />
            <Link to="/customers"> کلاینت ها </Link>
          </button>
        </div>

        <div className="sidebar-link">
          <button>
            <FontAwesomeIcon className="font-aw" icon={faList} />
            <Link to="/all-user">کاربر ها</Link>
          </button>
        </div>

        <div className="sidebar-link">
          <button>
            <FontAwesomeIcon className="font-aw" icon={faList} />
            <label title="country" onClick={this.toggle.bind(this)}>
              کشورها
            </label>
          </button>
        </div>

        {this.state.country ? (
          <>
            <div className="sidebar-col">
              <Path title="لیست کشور ها" path="/country-list" />
            </div>

            <div className="sidebar-col">
              <Path title="کشور جدید" path="/new-country" />
            </div>
          </>
        ) : null}
        <div className="sidebar-link">
          <button>
            <FontAwesomeIcon className="font-aw" icon={faList} />
            <label title="job" onClick={this.toggle.bind(this)}>
              کار افرینی
            </label>
          </button>
        </div>

        {this.state.job ? (
          <div className="sidebar-col">
            <Path title="لیست کار افرینی ها " path="/entrepreneurships" />
            <Path title="کار افرینی جدید" path="/new-entrepreneurship" />
          </div>
        ) : null}
        <div className="sidebar-link">
          <button>
            <FontAwesomeIcon className="font-aw" icon={faList} />
            <label title="comments" onClick={this.toggle.bind(this)}>
              {" "}
              کامنت ها
            </label>
          </button>
        </div>

        {this.state.comments ? (
          <div className="sidebar-col">
            <Path title="تمامی کامنت ها" path="/all-comments" />
            <Path title="نیاز به تایید" path="/get-comments" />
            <Path title="کامنت های رد شده" path="/deleted-comments" />
          </div>
        ) : null}

        <div className="sidebar-link">
          <button>
            <FontAwesomeIcon className="font-aw" icon={faList} />
            <label title="giftCode" onClick={this.toggle.bind(this)}>
              کد تخفیف
            </label>
          </button>
        </div>

        {this.state.giftCode ? (
          <div className="sidebar-col">
            <Path title="کد تخفیف جدید" path="/create-gift-code" />
            <Path title="لیست تخفیف ها" path="/gift-codes" />
          </div>
        ) : null}

        <div className="sidebar-link">
          <button>
            <FontAwesomeIcon className="font-aw" icon={faList} />
            <label title="version" onClick={this.toggle.bind(this)}>
              ورژن اپ
            </label>
          </button>
        </div>

        {this.state.version ? (
          <div className="sidebar-col">
            <Path title="ویرایش ورژن اپ" path="/app-version" />
          </div>
        ) : null}
      </div>
    );
  }

  toggle(event) {
    const name = event.target.title;
    console.log(event.target.title);
    this.setState({ [name]: !this.state[name] });
  }
}

function Path(props) {
  const { path, title } = props;
  return (
    <Link to={path}>
      <FontAwesomeIcon className="font-aw" icon={faCircleNotch} />
      <span>{title}</span>
    </Link>
  );
}
